import React from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import "./CopyModal.css";
import { connect } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import { showCopyModalAction } from "../../redux/actions/copyModal";
import { getCopyConfigApi, copyApi } from "../../api/issues";
import { toast } from "react-toastify";

class CopyModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      titleID: "",
      tocChecked: false,
      isLoading: false,
      destinations: [],
      selectedDestination: null
    };
    this.handleEnterTitleID = this.handleEnterTitleID.bind(this);
    this.handleCopyClicked = this.handleCopyClicked.bind(this);
    this.closeCopyModal = this.closeCopyModal.bind(this);
    this.handleTocChecked = this.handleTocChecked.bind(this);
    this.destinationSelected = this.destinationSelected.bind(this);
  }

  componentDidMount() {
    const { isPdf, issueID } = this.props;
    this.getCopyDestinations(isPdf, issueID);
  }

  componentDidUpdate(prevProps) {
    const { isPdf, issueID } = this.props;

    if (isPdf !== prevProps.isPdf || issueID !== prevProps.issueID) {
      this.getCopyDestinations(isPdf, issueID);
    }
  }

  destinationSelected(key) {
    if (this.state.isLoading) {
      return;
    }

    this.setState({ selectedDestination: key });
  }

  handleEnterTitleID(event) {
    if (this.state.isLoading) {
      return;
    }

    this.setState({ titleID: event.target.value });
  }

  async handleCopyClicked() {
    const { isPdf, issueID } = this.props;
    const {
      titleID,
      tocChecked,
      selectedDestination,
      destinations,
      isLoading
    } = this.state;

    if (selectedDestination == null) {
      toast.error("Please select a destination");
      return;
    }

    if (!titleID.trim().match(/^[0-9a-f]{24}$/i)) {
      toast.error("Invalid title ID");
      return;
    }

    if (isLoading) {
      return;
    }

    this.setState({ isLoading: true });

    try {
      const selectedDestinationData = destinations.filter(
        destination => destination.api_token === selectedDestination
      )[0];
      await copyApi(
        isPdf,
        issueID,
        titleID,
        selectedDestinationData.name,
        tocChecked
      );
    } catch (e) {
      toast.error(e.toString());
    }

    this.setState({ isLoading: false });
    toast.success("Copy success");
    this.closeCopyModal();
  }

  handleTocChecked(event) {
    if (this.state.isLoading) {
      return;
    }

    this.setState({ tocChecked: !this.state.tocChecked });
  }

  closeCopyModal() {
    this.props.showCopyModalAction({ showCopyMoal: false });
    this.setState({
      titleID: "",
      selectedDestination: null,
      tocChecked: false
    });
  }

  async getCopyDestinations() {
    const { isPdf, issueID } = this.props;

    try {
      const data = await getCopyConfigApi(isPdf, issueID);
      this.setState({
        destinations: data.destinations == null ? [] : data.destinations
      });
    } catch (e) {
      toast.error(e.toString());
    }
  }

  render() {
    const {
      titleID,
      destinations,
      isLoading,
      tocChecked,
      selectedDestination
    } = this.state;
    const selectedDestinationData = destinations.filter(
      destination => destination.api_token === selectedDestination
    )[0];

    return (
      <Modal
        show={this.props.showCopyModal}
        onHide={this.closeCopyModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Copy</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Container>
            <Row>
              <Col md="12">
                <Form.Control
                  className="copy_title_id_text"
                  autoFocus
                  value={titleID}
                  type="text"
                  placeholder="Title ID"
                  onChange={this.handleEnterTitleID}
                />
              </Col>
            </Row>
            <Row>
              <Col xs="8" sm="8" md="8">
                <DropdownButton
                  disabled={isLoading}
                  className="copy_dropdown"
                  id="copy_target"
                  variant="secondary"
                  title={
                    selectedDestination == null
                      ? "Destination"
                      : selectedDestinationData.name
                  }
                >
                  {destinations.map(destination => (
                    <Dropdown.Item
                      key={destination.api_token}
                      active={destination.api_token === selectedDestination}
                      onClick={() =>
                        this.destinationSelected(destination.api_token)
                      }
                    >
                      {destination.name}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              </Col>
              <Col xs="4" sm="4" md="4">
                <Form.Check
                  id="toc_only"
                  custom
                  label="TOC Only"
                  type="checkbox"
                  className="toc_check_box"
                  checked={tocChecked}
                  onChange={this.handleTocChecked}
                />
              </Col>
            </Row>
          </Container>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={this.closeCopyModal}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={this.handleCopyClicked}
            disabled={isLoading}
          >
            Copy
          </Button>
          <div className="spinner_container">
            {" "}
            {isLoading && <Spinner animation="grow" />}
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapState = state => {
  const { copyModal } = state;

  return copyModal;
};

const mapDispatch = {
  showCopyModalAction
};

export default connect(
  mapState,
  mapDispatch
)(CopyModal);
